export default {
  EARNED_POINTS: 'earnedPoints',
  GAMES_PLAYED: 'gamesPlayed',
  GAMES_PLAYED_PERCENTAGE: 'gamesPlayedPercentage',
  ISLANDS_PLAYED_PERCENTAGE: 'islandsPlayedPercentage',
};
